// A body-mounted overlay is positioned once, in page coordinates, so it stays under its trigger
// only while the trigger stays put. Scrolling and a window resize are already handled by the
// overlay itself -- both close it -- but a reflow that moves the trigger sideways (a sidebar
// opening, a column changing width, content arriving above it) fires neither event, and nothing
// reports that an element has merely moved: a size observer sees nothing when a box only shifts.
// So the position is sampled per frame while the overlay is open, the one signal that catches every
// cause, and the callback runs only when the answer moves.

const hasMoved = (last, rect) =>
  null === last || Math.round(last.left) !== Math.round(rect.left) || Math.round(last.top) !== Math.round(rect.top)

export default function followTrigger(element, onMove) {
  if (!element || 'function' != typeof requestAnimationFrame) return () => {}

  let frame = 0
  let last = null

  const sample = () => {
    const rect = element.getBoundingClientRect()

    if (hasMoved(last, rect)) {
      // The first sample records where the trigger stood when the overlay opened. The overlay is
      // already aligned to it, so there is nothing to correct yet.
      const isFirstSample = null === last

      last = { left: rect.left, top: rect.top }

      if (!isFirstSample) onMove()
    }

    frame = requestAnimationFrame(sample)
  }

  frame = requestAnimationFrame(sample)

  return () => {
    if (frame) cancelAnimationFrame(frame)
    frame = 0
  }
}
